import { render } from "./EventDetails.vue?vue&type=template&id=57c9bc56"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sindreglomnes/Documents/Dataing/Testing/VueCourse/real-world-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__